import { spacing } from 'studio/helpers';

export default theme => ({
  email: {
    marginTop: theme.spacing(3)
  },
  emails: {
    marginTop: theme.spacing(1),
    '& .MuiChip-root': {
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  userType: {
    marginTop: theme.spacing(2)
  },
  updateWarning: {
    marginTop: theme.spacing(2),
    marginBottom: -spacing(theme, 2)
  }
});
